import { BehaviorSubject } from 'rxjs';
import { IMenu } from './shared/models/menu';

export const menu$ = new BehaviorSubject<IMenu[]>([
  {
    route: "mainMenu",
    name: "Action Items",
    type: "link",
    roles: ['Admin','Dev','User'],
    icon: "home"
  },
  {
    route: "search",
    name: "Search",
    type: "link",
    roles: ['Admin','Dev','User'],
    icon: "search"
  },
  {
    route: "reports",
    name: "Reports",
    type: "link",
    roles: ['Admin','Dev','User'],
    icon: "book"
  },
  {
    route: "admin",
    name: "Administration",
    type: "link",
    roles: ['Admin','Dev'],
    icon: "settings"
  },
  {
    route: "help",
    name: "Help",
    type: "link",
    icon: "help"
  }
]);
